export default __webpack_public_path__ + "static/media/Trevor2.4e5bffae.png";